import SearchMonitoringQueueEntriesForm from './SearchMonitoringQueueEntriesForm';

export default SearchMonitoringQueueEntriesForm;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/index.js